/**
 * @typedef RoleUser
 * @type {Object}
 * @property {Number} id
 * @property {String} firstName
 * @property {String} lastName
 * @property {String} mobileNo
 * @property {String} [email]
 */
export const RoleUser = {}

/**
 * @typedef RoleHome
 * @type {Object}
 * @property {Number} id
 * @property {String} addressNo
 */
export const RoleHome = {}

/**
 * @typedef RoleProject
 * @type {Object}
 * @property {String} id
 * @property {String} name
 * @property {String} code
 * @property {String} icon
 */
export const RoleProject = {}

/**
 * @typedef RoleItem
 * @type {Object}
 * @property {Number} id
 * @property {String} role
 * @property {RoleUser} user
 * @property {RoleHome} home
 * @property {RoleProject} project
 * @property {String} createdAt
 */
export const RoleItem = {}

export class NonScUserRoleCommon {

  /** @type {RoleUser} */
  static user = {
    id        : null,
    firstName : null,
    lastName  : null,
    email     : null,
    mobileNo  : null
  }

  /** @type {RoleHome} */
  static home = {
    id        : null,
    addressNo : null
  }

  /** @type {RoleProject} */
  static project = {
    id    : null,
    code  : null,
    icon  : null,
    name  : null
  }

  /** @type {RoleItem} */
  static item = {
    id        : null,
    role      : null,
    user      : this.user,
    home      : this.home,
    project   : this.project,
    createdAt : null
  }
}
